// extracted by mini-css-extract-plugin
export var background = "_5v-0";
export var container = "_5v-1";
export var contentItem = "_5v-7";
export var extendedWarranty = "_5v-5";
export var link = "_5v-d";
export var modal = "_5v-b";
export var modalCloseButton = "_5v-9";
export var modalContent = "_5v-3";
export var modalContentMain = "_5v-6";
export var modalImageLogo = "_5v-8";
export var modalLogo = "_5v-a";
export var modalSideImage = "_5v-4";
export var preview = "_5v-c";
export var redoModal = "_5v-2";